<div class="flex-1 min-h-0 flex flex-col">
    <uat-banner></uat-banner>
    <router-outlet></router-outlet>
</div>

